import { render, staticRenderFns } from "./userBasicInformationInsideSearch.vue?vue&type=template&id=9dd83ee4&"
import script from "./userBasicInformationInsideSearch.vue?vue&type=script&lang=ts&"
export * from "./userBasicInformationInsideSearch.vue?vue&type=script&lang=ts&"
import style0 from "./userBasicInformationInsideSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports